module.exports = __webpack_public_path__ + "static/media/TelegramLogo.bd8eeac9.svg";


//////////////////
// WEBPACK FOOTER
// ./client/src/img/TelegramLogo.svg
// module id = 422
// module chunks = 0